import { ITrangThaiKhoChiTietRequest } from "../../model/request/quan-ly-kho/ITrangThaiKhoChiTietRequest";
import { ITrangThaiKhoSearchRequest } from "../../model/request/quan-ly-kho/ITrangThaiKhoSearchRequest";
import { apiClient } from "../apiClient";

export const UF_TRANGTHAIKHO_API_RESOURCE = "uf_trangthaikho";

export const ufTrangThaiKhoApi = {
    Select: (payload: ITrangThaiKhoSearchRequest) => apiClient.post(`${UF_TRANGTHAIKHO_API_RESOURCE}/select`, payload),
    SelectChiTiet: (payload: ITrangThaiKhoChiTietRequest) => apiClient.post(`${UF_TRANGTHAIKHO_API_RESOURCE}/select-chitiet`, payload),
    ExportExcel: (payload: ITrangThaiKhoSearchRequest) => apiClient.postBlob(`${UF_TRANGTHAIKHO_API_RESOURCE}/export-excel`, payload),
    ExportChiTietExcel: (payload: ITrangThaiKhoChiTietRequest) => apiClient.postBlob(`${UF_TRANGTHAIKHO_API_RESOURCE}/export-chitiet-excel`, payload),
};
